export const ZipUtilities = {
  format: (zipId: number) => {
    return ("00000" + zipId).slice(-5);
  },

  isFiveDigitString(text: string): boolean {
    return text.length == 5 && (text.match(/\d+/g) || []).join('').length == 5;
  }
};
